export interface MissionsState {
  masters: {
    byId: Record<string, MasterMission>;
    allIds: string[];
  };
  versions: {
    byMasterId: Record<string, Version[]>;
    loading: Record<string, boolean>;
  };
  selectedMasterId: string | null;
  selectedVersionId: string | null;
  loading: boolean;
  error: string | null;
}

export const initialState: MissionsState = {
  masters: {
    byId: {},
    allIds: [],
  },
  versions: {
    byMasterId: {},
    loading: {},
  },
  selectedMasterId: null,
  selectedVersionId: null,
  loading: false,
  error: null,
};
